/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IncludeContactType } from './IncludeContactType';
import {
	IncludeContactTypeFromJSON,
	IncludeContactTypeFromJSONTyped,
	IncludeContactTypeToJSON,
} from './IncludeContactType';
import type { IncludeServiceContactType } from './IncludeServiceContactType';
import {
	IncludeServiceContactTypeFromJSON,
	IncludeServiceContactTypeFromJSONTyped,
	IncludeServiceContactTypeToJSON,
} from './IncludeServiceContactType';

/**
 * A payload containing resourceIds to get the associated client entity
 * @export
 * @interface GetAssociatedClientsForResources
 */
export interface GetAssociatedClientsForResources {
	/**
	 *
	 * @type {Array<string>}
	 * @memberof GetAssociatedClientsForResources
	 */
	subjectRIDs?: Array<string>;
	/**
	 *
	 * @type {IncludeContactType}
	 * @memberof GetAssociatedClientsForResources
	 */
	includeClientContactType?: IncludeContactType;
	/**
	 *
	 * @type {IncludeServiceContactType}
	 * @memberof GetAssociatedClientsForResources
	 */
	includeServiceContactType?: IncludeServiceContactType;
}

/**
 * Check if a given object implements the GetAssociatedClientsForResources interface.
 */
export function instanceOfGetAssociatedClientsForResources(value: object): boolean {
	let isInstance = true;

	return isInstance;
}

export function GetAssociatedClientsForResourcesFromJSON(
	json: any
): GetAssociatedClientsForResources {
	return GetAssociatedClientsForResourcesFromJSONTyped(json, false);
}

export function GetAssociatedClientsForResourcesFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): GetAssociatedClientsForResources {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		subjectRIDs: !exists(json, 'subjectRIDs') ? undefined : json['subjectRIDs'],
		includeClientContactType: !exists(json, 'includeClientContactType')
			? undefined
			: IncludeContactTypeFromJSON(json['includeClientContactType']),
		includeServiceContactType: !exists(json, 'includeServiceContactType')
			? undefined
			: IncludeServiceContactTypeFromJSON(json['includeServiceContactType']),
	};
}

export function GetAssociatedClientsForResourcesToJSON(
	value?: GetAssociatedClientsForResources | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		subjectRIDs: value.subjectRIDs,
		includeClientContactType: IncludeContactTypeToJSON(value.includeClientContactType),
		includeServiceContactType: IncludeServiceContactTypeToJSON(
			value.includeServiceContactType
		),
	};
}
